import React from 'react';
import styled from 'styled-components';
import WifiIosIcon from '../../../assets/departureWifi/icon_wifi_ios.png';
import ArrowIosIcon from '../../../assets/departureWifi/icon_arrow_ios.png';
import WifiIcon from '../../../assets/departureWifi/icon_wifi.png';
import { WIFI } from '@/constant/departure.const';
import ArrowIcon from '../../../assets/departureWifi/icon_arrow.png';

type Props = {
  place?: 'airport' | 'port';
};

function IosWifiConnectionCheck({ place = 'airport' }: Props) {
  return (
    <WifiList>
      <WifiItem>
        <WifiDescription>
          1. 설정 <img src={ArrowIcon} width={12} alt='' /> Wi-Fi
        </WifiDescription>
        <WifiName>
          <WifiNameLeft>
            <img src={WifiIosIcon} alt='' width={16} /> Wi-Fi
          </WifiNameLeft>
          <img src={ArrowIosIcon} alt='' width={11} />
        </WifiName>
      </WifiItem>
      <WifiItem>
        <WifiDescription>
          2. {place === 'airport' ? '공항' : '항구'} 와이파이 연결
        </WifiDescription>
        <WifiName>
          {WIFI[place]} <img src={WifiIcon} width={16} alt='' />
        </WifiName>
      </WifiItem>
    </WifiList>
  );
}

const WifiList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  background-color: #f5f6f7;
`;

const WifiItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const WifiDescription = styled.dt`
  font-size: 12px;
  font-weight: 600;
  color: #3a3b3e;
`;

const WifiName = styled.dd`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 12px;
  color: #030303;
`;

const WifiNameLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

export default IosWifiConnectionCheck;
